module.exports = __webpack_public_path__ + "img/zilliqa.92642976.png";